import { apiClient } from '@/api/client'
import type { SiteInfoResponse } from './types'

export async function fetchSiteInfo(controllerId: string): Promise<SiteInfoResponse> {
  const { data } = await apiClient.get<SiteInfoResponse>(`/portal/controllers/api/v2/site-info/${controllerId}`)
  return data
}
